import { Intent } from '@blueprintjs/core';
import { DateInput } from '@blueprintjs/datetime';
import * as React from 'react';
import { Field } from 'react-final-form';

import useClientTranslations from '../../../../hooks/useClientTranslations';
import { TractableFormGroup } from './Shared';

const required = (text: string) => (value: any) => value ? undefined : text;

const DateOfInspection: React.FC = () => {
	const { t } = useClientTranslations();

	return (
		<Field name="dateOfAccident" validate={required(t('Date of accident is required'))}>
			{({ input, meta }) => (
				<TractableFormGroup
					label={t('Date of accident')}
					inline
					intent={Intent.DANGER}
					helperText={meta.invalid && meta.touched && meta.error}
				>
					<DateInput
						{...input}
						placeholder={t('DD/MM/YYYY')}
						formatDate={(date) => date.toLocaleDateString()}
						parseDate={(str) => new Date(str)}
						value={input.value || null}
						inputProps={{ name: 'dateOfAccident' }}
					/>
				</TractableFormGroup>
			)}
		</Field>
	);
};

export { DateOfInspection };
